import UserIcon from "../../assets/img/user-icon.svg";
import useTranslator from "../../hooks/useTranslator";
import { GoPlus } from "react-icons/go";
import VectorIcon from "../../assets/img/VectorIcon1.svg";
import { useState } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";

const FlatmateDetailCard = ({
  sharer,
  handleClick,
  loadingStates,
  llShowOnly,
  setShowDeleteConfirmationPrompt,
  setSelectedSharer,
}) => {
  const { _t } = useTranslator();
  const [isDropdown, setIsDropdown] = useState(false);

  return (
    <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
      <div className="earner-card mb-2" style={{ width: "95%" }}>
        <div className="earner-info guarantor-info align-items-center justify-content-between gap-2 d-flex">
          <div className="align-items-center gap-2 d-flex">
            <div className="earner-thumbnail-wrapper">
              <img src={UserIcon} alt="User Icon" />
            </div>
            <h4 className="earner-name">{sharer?.name ?? ""}</h4>
            <span className="earner-role">{_t(sharer?.relation) ?? ""}</span>
          </div>
          {llShowOnly && (
            <div
              className="cursor-pointer"
              onClick={() =>
                sharer?.status === "accepted" ? handleClick(sharer) : {}
              }
            >
              {sharer?.status === "pending" ? (
                <div className="viewMorebtn viewMorebtn2">
                  <p>{_t("pending")}</p>
                </div>
              ) : loadingStates[sharer.email] ? (
                <div className="inliveBtn">
                  <p>{_t("sending")}</p>
                </div>
              ) : sharer?.sharerId || sharer?.agencySharerId ? (
                <div>
                  <img
                    className="Imagerutate ImageSizeSet"
                    src={VectorIcon}
                    alt="Vector Icon"
                  />
                </div>
              ) : (
                <div className="inliveBtn text-white">
                  <p>
                    <GoPlus className="text-white" /> {_t("invite")}
                  </p>
                </div>
              )}
            </div>
          )}
          {!llShowOnly && sharer?.status === "pending" && (
            <div className="viewMorebtn viewMorebtn2">
              <p>{_t("pending")}</p>
            </div>
          )}
        </div>
      </div>
      {!llShowOnly && (
        <div className="position-relative">
          <MoreVertIcon
            className="cursor-pointer"
            onClick={() => setIsDropdown(!isDropdown)}
            style={{ color: "#141B34" }}
          />
          {isDropdown && (
            <div className="editDeleteDropdown fix-edit-delete-btn">
              <p
                className="deleteText custom-gap-2"
                onClick={() => {
                  setShowDeleteConfirmationPrompt(true);
                  setSelectedSharer(sharer);
                }}
              >
                <img src="/images/delete-icon.svg" alt="" />
                {_t("delete")}
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default FlatmateDetailCard;
